import { RecipientInfoDto } from 'app/models/api-dto.model';
import { ReportState, ReportType, ShareType } from 'shared/report/report.service.model';

export interface GetReportDto {
    name: string;
    description: string;
    icon: string;
    location: string;
    nextPublicationDate: string;
    reportRights: ReportRights;
    shareList: RecipientInfoDto[];
    shareType: ShareType;
    reportType: ReportType;
    id: string;
    siteId: string;
    state: ReportState;
}

export enum ReportRights {
    Read = 0,
    Write,
    Owner,
    NoAccess,
}
